export default {
  SET_CURRENT_USER (state, currentUserData) {
    state.currentUser = currentUserData
  }
}
